import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles({
	highlightedText: {
	}
});

const AdditionalInformation = () => {
	const classes = useStyles();

	return (
		<Box>
			<Typography component={Box} variant='h4' gutterBottom>Directions and notice to Federal contractor employees</Typography>
			<Typography paragraph variant='body2'>
				When the COVID-19 Community Level in a county where a Federal facility is located is MEDIUM or HIGH as defined by CDC, onsite contractor employees may be asked to attest to their vaccination status by being able to present a completed Certification of Vaccination form while in that Federal facility. 
				Please note that consistent with CDC guidance, agencies may have different or additional COVID-19 workplace safety protocols for individuals in specific work settings, such as healthcare or congregate settings, including protocols that vary based on an individual’s COVID-19 vaccination status.
			</Typography>
			<Typography paragraph variant='body2'>
				You may be asked to show this form and/or information from a health screening upon entry to a Federal facility, and/or to a Federal employee who is supervising or managing your work on Federal premises. 
				<b> Please maintain this form during your time on Federal premises</b>.
			</Typography>
			<Typography paragraph variant='body2'>
				Please contact IDRT WAR Room at 952-8883 or 952-8884 with questions.
			</Typography>
			<Typography component={Box} variant='h4' gutterBottom>Directions and notice to Visitors</Typography>
			<Typography paragraph variant='body2'>
				When the COVID-19 Community Level in a county where a Federal facility is located is MEDIUM or HIGH as defined by the CDC, visitors may be asked to attest to their vaccination status by being able to present a completed Certification of Vaccination form while in that Federal facility. 
				Please note that consistent with CDC guidance, agencies may have different or additional COVID-19 workplace safety protocols for people in specific work settings, such as healthcare or congregate settings, including protocols that vary based on an individual’s COVID-19 vaccination status.
			</Typography>
			<Typography paragraph variant='body2'>
				You may be asked to show this form and/or information from a health screening upon entry to a Federal facility, and/or to a Federal employee who is sponsoring your visit. You may be asked to show this form as part of your in-person participation in a Federally hosted meeting, event, or conference. <b>Please maintain this form during your visit.</b>
			</Typography>
			<Typography paragraph variant='body2'>
				If you are entering to obtain a public service or benefit and are not fully vaccinated, you must comply with all relevant CDC guidance, however using this form and following any requirement to show proof of a negative COVID-19 test do not apply to you.
			</Typography>
			<Typography paragraph variant='body2'>
				Please contact IDRT WAR Room at 952-8883 or 952-8884 with questions.
			</Typography>
			<Typography component={Box} variant='h4' gutterBottom>
				Directions and notice to Federal employees visiting a Federal agency other than their employing agency
			</Typography>
			<Typography paragraph variant='body2'>
			When the COVID-19 Community Level in a county where a Federal facility is located is MEDIUM or HIGH as defined by the CDC, Federal employees visiting a Federal agency other than their employing agency should be treated as visitors for the purposes of COVID-19 workplace safety protocols and should attest to their vaccination status by being able to present a completed
				Certification of Vaccination form while in that Federal facility. Please note that consistent with CDC guidance, agencies may have different or additional COVID-19 workplace safety protocols for people in specific work settings, such as healthcare or congregate settings, including protocols that vary based on an individual’s COVID-19 vaccination status.
			</Typography>
			<Typography paragraph variant='body2'>
				You may be asked to show this form and/or information from a health screening upon entry to a Federal facility controlled by a Federal agency other than your employing agency, and/or to a Federal employee who is sponsoring your visit. You may be asked to show this form as part of your in-person participation in a meeting, event, or conference hosted by a Federal agency other than your employing agency. 
				<b> Please maintain this form during your visit.</b>
			</Typography>
			<Typography paragraph variant='body2'>
				Making a false statement on this form could result in an adverse personnel action against you, up to and including removal from your position.
			</Typography>
			<Typography paragraph variant='body2'>
				Please contact IDRT WAR Room at 952-8883 or 952-8884 with questions.
			</Typography>
		</Box>

	);

};

export default AdditionalInformation;